<template lang="pug">
  v-container#top(fluid)
    v-layout.jumbotron(column align-center)
      v-flex.jumbotron-contents.text-xs-center
        h1.display-4(style="padding-bottom:0.3em;") All Releases
    v-layout#latest-releases.white.black--text(align-center)
      v-flex.text-xs-center
        h2.display-2 All releases
        v-layout.release-cards(fill-height justify-center row wrap)
            v-card(v-for="album in albums" :key="album")
              v-layout.release-card.elevation-5(row)
                v-flex.release-description(xs5)
                  v-card-title
                    p.caption.darken-1(style="margin:0") {{ album.id }}
                    p.title {{ album.title }}
                    p.caption.grey--text Theme: {{ album.theme }}
                  v-card-actions
                    v-btn.btn-mini(flat small color="orange" round target="_blank" :href="twitter_head + album.title + '%0a' + album.lead_text.join(' ') + twitter_bottom + '/' + album.id") Share
                    v-btn.btn-mini(flat small color="blue" round :href="album.download_url") Download
                v-flex(xs7)
                  v-card-media
                    a(:href="'release/' + album.id")
                      img.release-img(:src="require('../assets/images/albums-thumb/' + album.img_url)")
        v-btn.hrefbutton(href="about") About
          i.fas.fa-chevron-circle-right
        v-btn.hrefbutton.blue(href="contact") Contact
          i.fas.fa-chevron-circle-right

</template>

<script>
let db = require('@/assets/db.json');
let latest_release = db.releases
export default {
  data () {
    return {
      twitter_head: "https://twitter.com/intent/tweet?text=",
      twitter_bottom: "&hashtags=ツルレコ&url=" + encodeURIComponent(location.href),
      albums: latest_release
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
i {
  margin-left: 0.5em;
}
@mixin display-size-page {
  min-height: 100vh;
  min-width: 100vw;
  padding-right: 10%;
  padding-left: 10%;
}
@mixin slow {
  -webkit-transition: 0.3s ease-in-out;
  -moz-transition: 0.3s ease-in-out;
  -o-transition: 0.3s ease-in-out;
  transition: 0.3s ease-in-out;
}
#top {
  padding: 0;
}
#latest-releases {
  @include display-size-page;
  padding-top: 5em;
  padding-bottom: 3em;
  padding-right: 0;
  padding-left: 0;
}
.jumbotron {
  @include display-size-page;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/images/top.jpg");
}
.jumbotron-contents {
  @include display-size-page;
  padding-top: 30vh;
  background: rgba(0,0,0,0.4)
}
.hrefbutton {
  margin-top: 2em;
  width: 150px;
}
.release-cards {
  padding-top: 5em;
}
.release-card {
  border-radius: 5px;
  overflow: hidden;
  max-width: 378px;
  max-height: 220px;
  margin-right: 1em;
  margin-left: 1em;
  margin-bottom: 2em;
  padding: 0;
  .release-description {
    padding-top: 30px;
  }
  .release-img {
    max-width: 100%;
    max-height: 100%;
    margin-bottom: 1em;
    @include slow;
    &:hover {
      opacity: 0.5;
      filter: alpha(opacity=50);
      -ms-filter: "alpha(opacity=50)";
    }
  }
}
.btn-mini {
  margin-top: 0;
}
</style>
